import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Spinner from '../../Spinner';

export default function FireTeamAlertsModal(props) {  
    const {
        modal,
        setModal
    } = props;

    const [alert, setAlert] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (modal.content.alerts.filter((a) => a.incident_id === modal.content.fireId).length > 0) {
            setAlert(modal.content.alerts.filter((a) => a.incident_id === modal.content.fireId)[0]);
        }
    }, [modal.content?.alerts])

    const turnOnNotifications = () => {
        setLoading(true);
        modal.content.getToken()
        .then((token) => {
            axios.post('https://firewatch-api.space-eyes.com/user/notifications', 
            {
                team_id: null,
                area_id: null,
                incident_id: modal.content.fireId
            },
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
                modal.content.setAlerts([
                    ...modal.content.alerts.filter((a) => a.id !== response.data.id),
                    response.data
                ])
                setLoading(false);
                console.log('Alerts have been turned on.');
            }).catch((error) => {
                console.log('error turning on notifications', error);
                setLoading(false);
                setError('Trouble turning on notifications.');
            })
        })
        .catch((error) => {
            console.error('Failed to get token:', error);
            setError('Trouble turning on notifications.');
        });
    }

    const turnOffNotifications = (alertId) => {
         setLoading(true);
         modal.content.getToken()
         .then((token) => {
             axios.delete(`https://firewatch-api.space-eyes.com/user/notifications?id=${alertId}&team_id=${modal.content.teamId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
             }).then((response) => {
                modal.content.setAlerts(modal.content.alerts.filter((a) => a.id !== alert.id));
                setAlert(null);
                setLoading(false);
                console.log('Alerts have been turned off.');
             }).catch((error) => {
                setError('Trouble turning on notifications.');
                setLoading(false);
                setError('Trouble turning on notifications.');
             })
         })
         .catch((error) => {
            console.error('Failed to get token:', error);
            setError('Trouble turning on notifications.');
         });
    }

    return (
        <div className='fires-modal'>
            <div className='fires-modal-title'>Fire Team Alerts</div>
            <div className='fires-modal-content'>
                <div className='fires-modal-content-text'>Customize notification settings that apply to all your team members of real-time updates for this specific fire.</div>
            </div>
            {error && <div className='fires-modal-content-error'>{error}</div>}
            {loading ?
            <div style={{ paddingTop: '1rem' }}>
                <Spinner />
            </div>
            :
            <div className='fires-modal-content-alert-btns'>
                {!alert ?
                <div 
                    className='fires-modal-content-alert-btns-btn-save'
                    onClick={() => turnOnNotifications()}
                    >
                Turn On
                </div>
                :
                <div 
                    className='fires-modal-content-alert-btns-btn-off'
                    onClick={() => turnOffNotifications(alert.id)}
                    >
                Turn Off
                </div>
                }
                <div 
                    className='fires-modal-content-alert-btns-btn-cancel'
                    onClick={() => {
                        setModal({
                            type: false,
                            content: null
                        })
                    }}
                    >
                    Cancel
                </div>
            </div>
            }
        </div>
        // !user ?
        // <MiniLoginCard tempNavigation={navigation}/>
        // :
        // alerts ?
        // <View style={styles.notficationsContainer}>
        //     <Text style={styles.notficationsTitle}>Fire Team Alerts</Text>
        //     <Text style={styles.notficationsDescription}>Customize notification settings that apply to all your team members of real-time updates for this specific fire.</Text>
        //     <View style={styles.notficationCheckboxContainer}>
        //     {loading ?
        //         <Spinner />
        //         :
        //         !alert ?
        //         <Pressable
        //             style={
        //                 ({ pressed }) => [
        //                     styles.notficationsSaveBtn, { backgroundColor: pressed ? '#1668ba' : '#0080ff' }
        //                 ]
        //             }
        //             onPress={() => {
        //                 turnOnNotifications();
        //             }}
        //             >
        //             <Text style={styles.notficationsSaveBtnText}>Turn On</Text>
        //         </Pressable>
        //         :
        //         <Pressable 
        //             style={
        //                 ({ pressed }) => [
        //                     styles.notficationsTurnOffBtn, { backgroundColor: pressed ? '#f32a1c' : '#f44336' }
        //                 ]
        //             }
        //             onPress={() => {
        //                 turnOffNotifications(alert.id);
        //             }}
        //             >
        //             <Text style={styles.notficationsTurnOffBtnText}>Turn Off</Text>
        //         </Pressable>
        //         }
        //     </View>
        // </View>
        // :
        // <></>
    )

    // return (
    //     !user ?
    //     <MiniLoginCard tempNavigation={navigation}/>
    //     :
    //     alerts ?
    //     <View style={styles.notficationsContainer}>
    //         <Text style={styles.notficationsTitle}>Fire Alerts</Text>
    //         <Text style={styles.notficationsDescription}>Customize notification settings of real-time updates for this specific fire.</Text>
    //         <View style={styles.notficationCheckboxContainer}>
    //             <Pressable
    //                 onPress={() => {
    //                     setOptions({
    //                         ...options,
    //                         email: !options.email
    //                     })
    //                 }}
    //             >
    //                 <View
    //                     style={styles.notificationCheckbox}
    //                 >
    //                     <Text style={styles.notificationCheckboxTitle}>Email</Text>
    //                     {options.email &&
    //                     <Image source={checkIcon} style={{width: 17, height: 17}}/>
    //                     }
    //                 </View>
    //                 <Text style={styles.emailText}>{user.idToken.payload.email}</Text>
    //             </Pressable>
    //             <Pressable
    //                 onPress={() => {
    //                     setOptions({
    //                         ...options,
    //                         notification: !options.notification
    //                     })
    //                 }}
    //             >
    //                 <View
    //                     style={styles.notificationCheckbox}
    //                 >
    //                     <Text style={styles.notificationCheckboxTitle}>App Push Notifications</Text>
    //                     <View style={styles.notficationCheckboxComingSoonContainer}>
    //                         <Text style={styles.notficationCheckboxComingSoonContainerText}>COMING SOON</Text>
    //                     </View>
    //                     {options.notification &&
    //                     <Image source={checkIcon} style={{width: 17, height: 17}}/>
    //                     }
    //                 </View>
    //             </Pressable>
    //             {
    //             loading ?
    //             <Spinner />
    //             :
    //             !alert ?
    //             <Pressable
    //                 style={
    //                     ({ pressed }) => [
    //                         styles.notficationsSaveBtn, { backgroundColor: pressed ? '#1668ba' : '#0080ff' }
    //                     ]
    //                 }
    //                 onPress={() => {
    //                     turnOnNotifications();
    //                 }}
    //                 >
    //                 <Text style={styles.notficationsSaveBtnText}>Turn On</Text>
    //             </Pressable>
    //             :
    //             (alert && (alert.email !== options.email || alert.notification !== options.notification)) ?
    //             <Pressable
    //                 onPress={() => {
    //                     changeNotifications();
    //                 }}
    //                 style={
    //                     ({ pressed }) => [
    //                         styles.notficationsSaveBtn, { backgroundColor: pressed ? '#1668ba' : '#0080ff' }
    //                     ]
    //                 }
    //                 >
    //                 <Text style={styles.notficationsSaveBtnText}>Save Changes</Text>
    //             </Pressable>
    //             :
    //             <Pressable 
    //                 style={
    //                     ({ pressed }) => [
    //                         styles.notficationsTurnOffBtn, { backgroundColor: pressed ? '#f32a1c' : '#f44336' }
    //                     ]
    //                 }
    //                 onPress={() => {
    //                     turnOffNotifications(alert.id);
    //                 }}
    //                 >
    //                 <Text style={styles.notficationsTurnOffBtnText}>Turn Off</Text>
    //             </Pressable>
    //             }
    //         </View>
    //     </View>
    //     :
    //     <></>
    // )
}

